var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{on:{"click":_vm.order}},[_c('span',{staticStyle:{"padding":"0 4px"}},[_c('i',{class:_vm.iconClass})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }